import { HeadContent, Outlet, useLocation } from "@tanstack/react-router";
import { observer } from "mobx-react-lite";
import { useEffect } from "react";

import { Sidebar as RightBar } from "@synthesis/shared-ui";

import { Header } from "./components/header";
import { SideBar } from "./components/side-bar";
import { usePrompt } from "./hooks/use-prompt";
import { RolesContext } from "./roles-context";
import { useUserRolesGGE } from "./hooks/use-user-roles-gge";
import { FileSystemWorkerProvider, useFileSystemWorker } from "../modules/filesystem";

const AppLayoutInner = observer(() => {
  const location = useLocation();
  const { workerStore } = useFileSystemWorker();
  const uploading = workerStore.uploading;
  usePrompt(uploading, "Загрузка файлов в процессе. Вы уверены, что хотите покинуть страницу?");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <div className="flex">
      <RightBar>
        <SideBar />
        <main id="main-content" className="bg-neutrals-99 flex min-h-screen w-[calc(100%-270px)] flex-1 flex-col duration-200 ease-in-out">
          <Header />
          <div className="relative flex flex-1 flex-col">
            <Outlet />
          </div>
        </main>
      </RightBar>
    </div>
  );
});

export const AppLayout = () => {
  const userRoles = useUserRolesGGE();

  return (
    <FileSystemWorkerProvider>
      <RolesContext.Provider value={userRoles}>
        <HeadContent />
        <AppLayoutInner />
      </RolesContext.Provider>
    </FileSystemWorkerProvider>
  );
};
